// GENERATED by scripts/build-icons.mjs from icons/network.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Network = createIcon('network', [
  ['rect', { x: "16", y: "16", width: "6", height: "6", rx: "1" }],
  ['rect', { x: "2", y: "16", width: "6", height: "6", rx: "1" }],
  ['rect', { x: "9", y: "2", width: "6", height: "6", rx: "1" }],
  ['path', { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" }],
  ['path', { d: "M12 12V8" }],
])
